export const hasReportsCapability = (features) => features?.reports === true;
